import type { Components, Theme } from "@mui/material";

export const listItemIconTheme: Components<Theme>["MuiListItemIcon"] = {
  styleOverrides: {
    root: ({ theme }) => ({
      minWidth: "unset",
      marginRight: theme.spacing(1),
      color: theme.palette.text.main,
      "& svg": {
        width: 20,
        height: 20,
      },
    }),
  },
};
